import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS].GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS]: {
		url:'/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/staff_groups/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS].GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP_PREVIEW]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/staff_groups/:staffGroupsId/preview/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS].GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP_POPUP]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/staff_groups/:staffGroupsId/popup/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS].GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/staff_groups/:staffGroupsId/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS].CREATE_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP]: {
		url:'/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/staff_groups/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS].PATCH_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/staff_groups/:staffGroupsId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS].PUT_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/staff_groups/:staffGroupsId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS].DELETE_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/staff_groups/:staffGroupsId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}